import Treatment from './Treatment.container';

export default Treatment;
